<template>
  <v-card outlined :loading="loading" :min-width-400="$vuetify.breakpoint.smAndUp" :min-width-300="$vuetify.breakpoint.xsOnly">
    <v-snackbar v-model="snackbar.show" top :color="snackbar.color">
      {{ snackbar.text }}
    </v-snackbar>

    <v-card-title>
      <div class="subtitle-1">{{ companyName }}</div>
    </v-card-title>
    <v-card-subtitle>
      <div class="ml-4 headline">Reset your password</div>
    </v-card-subtitle>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-text-field
          label="Email"
          name="email"
          type="text"
          disabled
          v-model="data.email"
          prepend-inner-icon="email"
          outlined
        ></v-text-field>
        <v-text-field
          label="Password"
          name="password"
          type="password"
          :rules="[rules.required]"
          v-model="data.password"
          prepend-inner-icon="lock"
          outlined
          autofocus
        ></v-text-field>
        <v-text-field
          label="Confirm password"
          name="password2"
          type="password"
          :rules="[rules.required]"
          :error-messages="matchPassword"
          v-model="password2"
          prepend-inner-icon="lock"
          outlined
        ></v-text-field>
        <v-btn
          :disabled="!valid"
          large block color="success lighten-1"
          @click="reset"
        >
          Submit
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import UserService from '@/services/UserService.js'

export default {
  name: 'Reset',
  data: () => ({
    loading: false,
    valid: false,
    data: { email: '', code: '', password: '' },
    password2: '',
    rules: {
      required: v => !!v || 'Required'
    },
    snackbar: {
      show: false,
      color: null,
      text: null
    }
  }),
  computed: {
    ...mapGetters([
      'companyName'
    ]),
    matchPassword () {
      return this.data.password === this.password2 ? '' : 'Password must match'
    }
  },
  methods: {
    setData (email, code) {
      this.data.email = email
      this.data.code = code
    },
    reset () {
      this.loading = true
      UserService.resetPassword(this.data)
        .then(resp => {
          this.loading = false
          this.$refs.form.resetValidation()
          this.$emit('set-auth-state', {
            state: 'signin',
            email: this.data.email,
            message: 'Reset sucessful! Please sign in with your password.'
          })
        })
        .catch(err => {
          console.error(err)
          this.loading = false
          this.$refs.form.resetValidation()
          this.snackbar.show = true
          this.snackbar.color = 'error'
          this.snackbar.text = 'Failed to reset password.'
        })
    },
    verifyCode () {
      this.loading = true
      UserService.verifyCode({ code: this.code })
        .then(resp => {
          this.loading = false
          this.$refs.form2.resetValidation()
        })
        .catch(err => {
          console.error(err)
          this.loading = false
          this.$refs.form2.resetValidation()
        })
    }
  }
}
</script>
